<!-- Verification.vue -->
<template>
    <div class="verification-content">
        <form @submit.prevent>
            <div>
                <h3>אימות מספר טלפון</h3>
                <input ref="codeInput" type="text" autofocus placeholder="קוד אימות" v-model="verificationCode"
                    :class="{ error: hasVerificationCodeError }">
                <div v-if="hasVerificationCodeError" class="errorMessage">{{ errorMessage }}</div>
                <div style="display: flex; justify-content: space-between">
                    <button @click="handleVerification" style="margin-left: 10px;">{{ codeButtonMessage }}</button>
                    <button @click="resendCode">שלח קוד שוב</button>
                </div>
            </div>
        </form>
        <div class="logo-container">
            <div>
                <img src="@/assets/logo.svg" alt="לוגו הדרך אל הלב" />
            </div>
            <h3>הדרך אל הלב</h3>
        </div>
    </div>
</template>
  
<script setup>
import { ref, toRaw, onMounted, computed } from "vue"
import router from '@/router';
import { states } from '../../main_store'
import { user } from '../../scripts/utils'


const verificationCode = ref("")
const hasVerificationCodeError = ref(false)
const verificationObject = toRaw(states.value.confirmationResult)
const errorMessage = ref("")
const codeInput = ref("codeInput")
const codeButtonMessage = computed(() => !isPending.value ? 'אמת קוד' : 'טוען')
const isPending = ref(false)

if (!states.value.confirmationResult) {
    router.push({ name: 'Login' })
}

const resendCode = async () => {
    router.push({ name: 'Login' })
}

const handleVerification = async () => {
    hasVerificationCodeError.value = verificationCode.value.trim() === ""
    errorMessage.value = ""

    if (hasVerificationCodeError.value) {
        errorMessage.value = "יש למלא את שדה קוד האימות."
        return
    }
    isPending.value = true

    try {
        // Use the confirmationResult to confirm the verification code
        await verificationObject.confirm(verificationCode.value)
        isPending.value = false
        // The user is now authenticated
        router.push({ name: "Home" });

    } catch (error) {
        isPending.value = false
        console.error("error logged: ", error)
        hasVerificationCodeError.value = true
        errorMessage.value = "קוד האימות לא אושר."
        // Handle error, e.g., show an error message to the user
    }
}

onMounted(() => {
    if (codeInput.value) {
        codeInput.value.focus();
    }
});

</script>
<style scoped>
.verification-content {
    width: 100%;
    height: 100%;
    direction: rtl;
    justify-content: center;
    align-items: center;
    text-align: center;
    overflow-y: hidden;
}

.verification-content>.logo-container {
    display: none;
    margin-top: 40%
}

@media only screen and (max-width: 600px) {
    .verification-content>.logo-container {
        display: inherit;
        margin-top: 40%
    }
}

form {
    direction: rtl;
    background: transparent;
    border: none;
    box-shadow: none;
}

.error {
    border: 1px solid rgb(248 113 113);
    border-radius: 10px;
    color: var(--primary);
}

.errorMessage {
    color: rgb(239 68 68);
    padding: 10px;
    margin: 16px 0px;
}
</style>